export const APP_PATHS = {
  // Public routes
  landing: '/',
  onboarding: '/onboarding',
  thankYou: '/thank-you',

  // Auth routes
  login: '/auth/login',
  register: '/auth/register',
  verifyEmail: '/auth/verify-email',
  resetPassword: '/auth/reset-password',

  // App routes (protected)
  dashboard: '/app/dashboard',
  users: '/app/users',
  settings: '/app/settings',

  // Feature routes
  projects: '/app/projects',
  projectDetail: '/app/projects/:id',

  // Admin routes (public with API key auth)
  admin: '/admin',
  adminUsers: '/admin/users',
  adminXUsers: '/admin/x-users',
  adminCategories: '/admin/categories',
} as const;
